import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import MostFightsWrestlerMobile from '../../../pages/Mobile/Stats/MostFightsWrestlerMobile';
import MostMatchesStats from '../../../pages/MostMatchesStats';

const MostFightsWrestlerResponsive = () => {
    const { isMobile } = useResponsiveRedux(); 
    return isMobile ? <MostFightsWrestlerMobile /> : <MostMatchesStats />;
}; 

export default MostFightsWrestlerResponsive;